import { jsx as _jsx } from "react/jsx-runtime";
import PagesCommonHeader from "../../../common_components/PagesCommonHeader";
const SemrushToolHeader = () => (_jsx(PagesCommonHeader, { height: "58px", title: "Semrush Tool" }));
export default SemrushToolHeader;
